import { getCartTitle } from 'common/helpers/miscHelper';

const Proceed = (props) => {
  const { cart, showViewCart = true, settings } = props;
  const title = getCartTitle(settings);
  if (!cart.items || cart.items.length === 0) {
    if (!showViewCart) {
      return null;
    }
    return (
      <div className="c7-cart__buttons">
        <a href="/cart" className="c7-button-alt">
          View {title}
        </a>
      </div>
    );
  }
  return (
    <div className="c7-cart__buttons">
      {showViewCart && (
        <a href="/cart" className="c7-button-alt">
          View {title}
        </a>
      )}
      <a href="/checkout" className="c7-button">
        Proceed to Checkout
      </a>
    </div>
  );
};

export default Proceed;
